import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import { Ban, LogOut, KeyRound } from "lucide-react";

export default function Rejected() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-50 text-stone-900 flex flex-col" data-testid="rejected-page">
      <header className="border-b border-stone-200 bg-white">
        <div className="mx-auto max-w-6xl px-6 py-4 flex items-center gap-3">
          <div className="h-9 w-9 rounded-md bg-amber-500 text-stone-900 flex items-center justify-center">
            <KeyRound className="h-5 w-5" />
          </div>
          <div className="text-sm font-semibold tracking-tight">KKS</div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <Card className="w-full max-w-lg border-stone-200">
          <CardContent className="py-10 text-center">
            <div className="mx-auto h-12 w-12 rounded-full bg-red-100 text-red-700 flex items-center justify-center mb-4">
              <Ban className="h-6 w-6" />
            </div>
            <h1 className="text-2xl font-semibold tracking-tight">
              Account not approved
            </h1>
            <p className="mt-3 text-stone-600">
              Hi {user?.name || "there"} — your KKS account application was
              not approved at this time. Please contact your administrator if
              you believe this is a mistake.
            </p>
            <Button
              variant="outline"
              className="mt-6"
              onClick={() => {
                signOut();
                navigate("/login", { replace: true });
              }}
              data-testid="rejected-signout-button"
            >
              <LogOut className="mr-2 h-4 w-4" /> Sign out
            </Button>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
